<script>
  import { Scatter, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins
  export default {
    name: 'scatter-chart',
    mixins: [reactiveProp],
    extends: Scatter,
    props: ['options'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>